import cn from 'classnames'

import { Tooltip } from 'core-components/library/tooltip'
import { useLineClampedText } from 'shared/lib/lineClamp'

import { TGroupedInitiativeRow } from '../../models'

import styles from './InitiativeColumn.module.scss'

export const InitiativeColumn = ({
  item,
  onEdit,
  nameMaxLines,
  descriptionMaxLines,
}: {
  item: TGroupedInitiativeRow
  onEdit?: (item: TGroupedInitiativeRow) => void
  nameMaxLines?: number
  descriptionMaxLines?: number
}) => {
  const { ref, isTruncated } = useLineClampedText(item.Description, descriptionMaxLines)
  const { ref: nameRef, isTruncated: isNameTruncated } = useLineClampedText(item.Name, nameMaxLines)
  const tooltipText = isNameTruncated
    ? [item.Name, item.Description].filter(Boolean).join('\n')
    : item.Description || item.Name
  const content = (
    <>
      <span
        ref={nameRef}
        style={{ WebkitLineClamp: nameMaxLines }}
        className={cn(styles.name, { [styles.previewName]: nameMaxLines !== undefined })}
      >
        {item.Name || '-'}
      </span>
      {item.Description && (
        <span
          ref={ref}
          style={{ WebkitLineClamp: descriptionMaxLines }}
          className={cn(styles.description, {
            [styles.previewDescription]: descriptionMaxLines !== undefined,
          })}
        >
          {item.Description}
        </span>
      )}
    </>
  )
  return (
    <Tooltip
      textAlign="left"
      className={styles.root}
      disabled={
        (descriptionMaxLines !== undefined || nameMaxLines !== undefined) &&
        !isTruncated &&
        !isNameTruncated
      }
      tipContent={() => <span className={styles.fullDescription}>{tooltipText}</span>}
    >
      {onEdit ? (
        <button type="button" className={styles.link} onClick={() => onEdit(item)}>
          {content}
        </button>
      ) : (
        <div className={styles.readOnly}>{content}</div>
      )}
    </Tooltip>
  )
}
